import React, { Component } from "react";

class Canny extends Component {
  constructor(props) {
    super(props);
    this.myCanvasOuput = React.createRef();
    this.myTextArea = React.createRef();
    this.state = {
      slidervalue1: 0,
      slidervalue2: 0,
      selectvalue:false,
      mycode: `let rect = new cv.Rect(0, 0, 500, 200);
    dst = src.roi(rect);`,
    };
  }

  handleChange(e) {
    console.log(e.target.id);
    this.setState({ [e.target.id]: e.target.value });
    this.update(e);
  }
  update(e) {
    const cv = window.cv;

    let previusCanvas = e.target
      .closest(".Component")
      .previousSibling.querySelector(".imageTarget");
    let currentOutputCanvas = this.myCanvasOuput.current;
    // console.log(previusCanvas); // select previus canvas as input
    let src = cv.imread(previusCanvas);
    let dst = new cv.Mat();
    cv.cvtColor(src, src, cv.COLOR_RGB2GRAY, 0);
    // You can try more different parameters
    cv.Canny(
      src,
      dst,
      parseFloat(this.state.slidervalue1),
      parseFloat(this.state.slidervalue2),
      3,
      this.state.selectvalue=="true"
    );
    cv.imshow(currentOutputCanvas, dst);
    src.delete();
    dst.delete();
  }
  // Render
  render() {
    return (
      <div className="Canny Component">
        <h2>Canny</h2>
        <input
          type="range"
          id="slidervalue1"
          onChange={(e) => this.handleChange(e)}
          min="0"
          max="255"
        />
        <span>Thresholding1 (High): {this.state.slidervalue1}</span>
        <input
          type="range"
          id="slidervalue2"
          onChange={(e) => this.handleChange(e)}
          min="0"
          max="255"
        />
        <span>Thresholding2 (Low): {this.state.slidervalue2}</span>

        <select name="select" value={this.state.selectvalue} onChange={(e)=>{this.setState({selectvalue : e.target.value});this.update(e);}}>
          <option value="false" selected>
            L1 norm
          </option>
          <option value="true">L2 norm</option>
        </select>
        {/* <button onClick={(e) => this.update(e)}>press</button> */}
        <div class="row">
          <div class="col-6">
            <canvas ref={this.myCanvasOuput} className="imageTarget"></canvas>
          </div>
        </div>
      </div>
    );
  }
}

export default Canny;
